/**
 * Global constants that are structural (not economy-balance) in nature.
 * Economy balance numbers live in economyConfig.ts so they can be tuned
 * without touching engine logic (see GAME_SPEC section 26).
 */

export const SAVE_VERSION = 1;

export const LOCALSTORAGE_KEYS = {
  SAVE: 'parking-tycoon:save',
  SETTINGS: 'parking-tycoon:settings',
} as const;

/** Scene keys used by Phaser. Kept centralized to avoid magic strings. */
export const SCENES = {
  BOOT: 'BootScene',
  MAIN_MENU: 'MainMenuScene',
  CITY: 'CityScene',
  PARKING_LOT: 'ParkingLotScene',
  UI: 'UIScene',
} as const;

/** Days of the week, index 0 = Monday (matches GameClock). */
export const DAY_NAMES = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
] as const;

export const MONTH_NAMES = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
] as const;

export const MINUTES_PER_HOUR = 60;
export const HOURS_PER_DAY = 24;
export const DAYS_PER_MONTH = 30;
export const MONTHS_PER_YEAR = 12;
export const DAYS_PER_WEEK = 7;

export const MINUTES_PER_DAY = MINUTES_PER_HOUR * HOURS_PER_DAY;
